const rad = deg => deg * Math.PI / 180

export default [
  {
    scrollValue: 0,
    camera: { position: [0, 0, 30], lookAt: [0, 0, 0] },

    face: {
      position: [0, -100, 0],
      rotation: [rad(-90), 0, 0],
      scale: [10, 0, 10]
    }
  },
  {
    scrollValue: 50,
    camera: { position: [0, 0, 20], lookAt: [0, 0, 0] },

    face: {
      position: [0, -10, 0],
      rotation: [rad(-90), 0, 0],
      scale: [1, 1, 1]
    }
  },
  {
    scrollValue: 100,
    camera: { position: [0, -5, 20], lookAt: [0, 0, 0] },

    face: {
      position: [0, -10, 0],
      rotation: [rad(-100), 0, rad(180)],
      scale: [1, 1, 1]
    }
  },
  {
    scrollValue: 150,
    camera: { position: [0, 20, 20], lookAt: [0, 0, 0] },

    face: {
      position: [0, -10, 0],
      rotation: [rad(-100), 0, rad(180)],
      scale: [1, 1, 1]
    }
  }
]
